import { makeStyles } from '@material-ui/core';

export const useTicketStateBaseStyles = makeStyles(() => ({
  container: {
    marginTop: (props) => (props.mobile ? null : 52),
    textAlign: 'center',
    color: '#464646',
    maxWidth: 500,
    margin: '0 auto',
  },
  image: {
    width: 114,
    height: 100,
  },
  divider: {
    marginTop: 30,
    marginBottom: 20,
  },
  buttonContainer: {
    width: '100%',
    display: (props) => (props.mobile ? 'flex' : 'flex'),
    flexDirection: (props) => (props.mobile ? 'column' : 'row'),
    justifyContent: (props) => (props.mobile ? null : 'space-between'),
    alignItems: 'center',
  },
  button: {
    width: 200,
    height: 40,
    marginBottom: 20,
  },
}));
